// markdown/remarkVideo.js
import { visit } from "unist-util-visit";

/**
 * Turns :::video src="..." poster="..." caption="...":::
 * into an mdast node we can render as a <Video /> component via react-markdown's components map.
 */
export const remarkVideo = function remarkVideo() {
	return (tree) => {
		visit(tree, (node) => {
			// remark-directive shape for container directives
			if (node.type === "containerDirective" && node.name === "video") {
				const { src, poster, caption, preload } = node.attributes || {};
				// Convert to a custom node that we'll catch in components map
				node.type = "leafDirective";
				node.data = {
					hName: "video-block",
					hProperties: { src, poster, caption, preload },
				};
				node.children = []; // no inner content needed
			}
		});
	};
};
